<div class="mobile-listing-pagination-container">
  <div class="divider"></div>

  <div class="additional-text">Total Results: {{ paginationInfo.totalItems }}</div>

  <div class="pagination-options">
    <div
      class="button"
      (click)="openItemsPerPageDropdown($event)"
      [ngClass]="{ disabled: paginationInfo.totalItems === 0 }"
    >
      <span>{{ userPaginationOption.pageSize }}/Page</span>
      <ion-icon
        [name]="isItemsPerPageCountDropdownOpen ? 'caret-up-outline' : 'caret-down-outline'"
        class="icon"
      ></ion-icon>
    </div>

    <div class="button" (click)="onPrevious()" [ngClass]="{ disabled: userPaginationOption.pageNo <= 1 }">
      <ion-icon [name]="'caret-back-outline'" class="icon"></ion-icon>
      <span>Previous</span>
    </div>

    <div class="additional-text">
      {{ paginationInfo.totalPageCount === 0 ? 0 : userPaginationOption.pageNo }}/{{ paginationInfo.totalPageCount }}
    </div>

    <div
      class="button"
      (click)="onNext()"
      [ngClass]="{
        disabled: userPaginationOption.pageNo === paginationInfo.totalPageCount || paginationInfo.totalPageCount === 0
      }"
    >
      <span>Next</span>
      <ion-icon [name]="'caret-forward-outline'" class="icon"></ion-icon>
    </div>
  </div>
</div>
